import { useSelector } from 'react-redux'
import type { BlastSource } from '../../../Model/Project/BlastSource.js'
import type { BlastStatistics } from '../../../Model/Project/IOtuProcessIdDTO.js'
import type { State } from '../../Slice/index.js'

export const useGetBlastStatistics = (projectId: string, blastType: BlastSource): BlastStatistics => {
  return useSelector((state: typeof State) => {
    const projectStats = state.project.blastStatistics[projectId]
    if (!projectStats) {
      return { loading: false }
    }

    return projectStats[blastType] || { loading: false }
  })
}
